import React, { useEffect } from "react";
import { isAuthenticated, scroolElement } from "utils/common";
import { useDispatch, useSelector } from "react-redux";
import { ChevronDown } from "assets/svg";
import { SERVICE } from "constants/global";
import { getQA } from "features/Questions/qaSlice";
import CardQA from "features/Questions/components/CardQA";
import ErrorDB from "components/ErrorDB";

function Question() {
  const dispatch = useDispatch();
  const { data, category,reference, isInLine } = useSelector((state) => state.qa);

  useEffect(() => {
    dispatch(getQA({ service: SERVICE }));
  }, []);

  return (
    <div className={isAuthenticated() ? "w-80" : "container px-0"}>
      <div className="fs-20 fs-sm-18 fw-600 sp-14 text-center py-3 py-md-4">
        よくあるご質問
      </div>

      <div className="mx-3 mx-lg-0 p-2 border-color-grey-2 border-radius-5 bg-f8 text-brown fs-12 fw-600">
        <ul className="p-0 m-0">
          {category?.map((item) => (
            <li key={item.id} className="cursor-pointer">
              <div onClick={() => scroolElement("#" + item.category, 100)}>
                <span className="d-inline-block me-2 mb-1">
                  <ChevronDown />
                </span>
                {item.category}
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="px-0 px-md-2 my-3 my-md-4 py-3 py-md-2 border-radius-5 border-radius-sm-none bg-f4 qa">
        {category?.map((cat) => (
          <div key={cat.id} id={cat.category} className="mb-3 mb-md-4">
            <div className="px-3 my-2 fw-bold sp-1">{cat.category}</div>
            <div className="d-flex flex-column px-3 py-0">
            {isInLine && <ErrorDB/>}
            {!isInLine && data?.map(
              (qa) => qa.category === cat.id && <CardQA qa={qa} key={qa.id} reference={reference} />
            )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Question;
